import React, { useState, useEffect, useRef, useMemo } from "react";
import styles from "./Invoice.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { toCommas } from "../../utils/utils";
import { useSnackbar } from 'react-simple-snackbar';
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import { initialState } from "../../initialState";
import currencies from "../../currencies.json";
import {
  createInvoice,
  getInvoice,
  updateInvoice,
} from "../../actions/invoiceActions";
import { formatDollarsToCents, formatCentsToDollars, dollarFormatter } from "../../utils/money";
import { getAccountsByUser } from "../../actions/accountActions";
import { getLocationsByUser } from "../../actions/locationActions";
import { getContactsByUser } from "../../actions/contactActions";
import { getProductsByUser } from "../../actions/productActions";
import { getLockupsByUser, updateLockup } from "../../actions/lockupActions";
import { getInventoriesByUser, updateInventory } from "../../actions/inventoryActions";
import { fetchTaxRate } from "../../api/index";
import InvoiceType from "./InvoiceType";
import { useLocation } from "react-router-dom";
import {Checkbox, FormGroup, FormControlLabel} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(1),
  },
}));

const Invoice = () => {
  const location = useLocation();
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [product, setProduct] = useState(null)
  const [lockup, setLockup] = useState(null)
  const [dno, setDno] = useState(null);
  const [rates, setRates] = useState(0.00);
  const [deliveryFee, setDeliveryFee] = useState(0.00);
  const [deliveryFeeOverride, setDeliveryFeeOverride] = useState(false);
  const [salesTax, setSalesTax] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedRbDate, setSelectedRbDate] = useState(
    moment().add(1, 'days')
  );
  const [selectedDate, setSelectedDate] = useState(
    moment(selectedRbDate).add(1, 'days')
  );
  const [haulAway, setHaulAway] = useState(false);
  const [walkUp, setWalkUp] = useState('');
  const [account, setAccount] = useState(null);
  const [locationTarget, setLocationTarget] = useState(null);
  const [contactTarget, setContactTarget] = useState(null);
  const [nextInvoiceNumber, setNextInvoiceNumber] = useState('');
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [type, setType] = useState("Invoice");
  const [status, setStatus] = useState("");
  const { id } = useParams();
  const accounts = useSelector((state) => state.accounts.accounts || []);
  const locations = useSelector((state) => state.locations.locations || []);
  const contacts = useSelector((state) => state.contacts.contacts || []);
  const products = useSelector((state) => state.products.products);
  const lockups = useSelector((state) => state.lockups.lockups);
  const inventories = useSelector((state) => state.inventories.inventories)
  const { invoice } = useSelector((state) => state.invoices);
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const originalItems = useRef(invoice ? invoice.items : [
      {modelNumber: '', unitPrice: '', quantity: '', discount: '', unitCost: '', doNotOrder: false, lockup: false},
  ]);
  console.log(originalItems)
  const originalQuantity = useRef('');
  useEffect(() => {
    if (locationTarget) {
      applyTaxRateFromLocation(locationTarget)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationTarget])

  useEffect(() => {
    if (id){
      dispatch(getInvoice(id));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const search = user?.result._id || user?.result?.googleId
    dispatch(
      getAccountsByUser({ search })
    );
    dispatch(
      getLocationsByUser({ search })
    );
    dispatch(
      getContactsByUser({ search })
    );
    dispatch(
      getProductsByUser({ search: user?.result._id || user?.result?.googleId })
    );
    dispatch(
      getLockupsByUser({ search: user?.result._id || user?.result?.googleId })
    );
    dispatch(
      getInventoriesByUser({ search: user?.result._id || user?.result?.googleId })
    );
    if (!id) {
      fetch(`${process.env.REACT_APP_API}/invoices/next-number`, { credentials: 'include' })
        .then(res => res.ok ? res.json() : Promise.reject(res.status))
        .then(data => setNextInvoiceNumber(data?.invoiceNumber || ''))
        .catch(() => setNextInvoiceNumber(''))
    }
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setHaulAway(Boolean(invoice.haulAway));
      setWalkUp(invoice.walkUp || '');
      setAccount(invoice.billTo || null);
      setLocationTarget(invoice.shipTo || null);
      setContactTarget(invoice.contact || null);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
      setSelectedRbDate(invoice.receivedByDate);
      setDeliveryFee(typeof invoice.deliveryFee === 'number' ? invoice.deliveryFee : 0);
      setDeliveryFeeOverride(Boolean(invoice.deliveryFeeOverride));
    }
  }, [invoice]);

  useEffect(() => {
    if (invoice?.billTo?.accountId && (!account || account._id !== invoice.billTo.accountId)) {
      const acc = accounts.find((a) => a._id === invoice.billTo.accountId)
      if (acc) setAccount(acc)
    }
    if (invoice?.shipTo?.locationId && (!locationTarget || locationTarget._id !== invoice.shipTo.locationId)) {
      const loc = locations.find((l) => l._id === invoice.shipTo.locationId)
      if (loc) setLocationTarget(loc)
    }
    if (invoice?.contact?.contactId && (!contactTarget || contactTarget._id !== invoice.contact.contactId)) {
      const con = contacts.find((c) => c._id === invoice.contact.contactId)
      if (con) setContactTarget(con)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, locations, contacts])

  useEffect(() => {
    if (type === "Receipt") {
      setStatus("Paid");
    } else {
      setStatus("Unpaid");
    }
  }, [type]);

const WALK_UP_FEES = {
  '3rd floor': 8,
  '4th floor': 12,
  '5th floor': 18,
  '6th floor': 22,
}

const getWalkUpFee = (walkUp) => WALK_UP_FEES[walkUp] || 0

  const defaultProps = {
    options: currencies,
    getOptionLabel: (option) => option.label,
  };

  const accountOptions = useMemo(() => accounts, [accounts])
  const locationOptions = useMemo(() => {
    if (!account) return locations
    return locations.filter((l) => l.accountId === account._id)
  }, [locations, account])
  const locationContactsForTarget = useMemo(() => {
    if (!locationTarget) return []
    const locContacts = Array.isArray(locationTarget.contacts) ? locationTarget.contacts : []
    if (locContacts.length) return locContacts
    if (Array.isArray(invoice?.contactList) && invoice.contactList.length) return invoice.contactList
    return contacts.filter((c) => c.locationId === locationTarget._id)
  }, [contacts, locationTarget, invoice])

  const productsProps = {
    options: products,
    getOptionLabel: (option) => option.modelNumber,
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleRbDateChange = (date) => {
    setSelectedRbDate(date);
    let days = account ? account.term : 1;
    let tomorrow = moment(date).add(days, 'days');
    setSelectedDate(tomorrow);
  };

  const handleRates = (e) => {
    setRates(e.target.value);
    setInvoiceData((prevState) => ({ ...prevState, tax: e.target.value }));
  };

  // Auto-assign contacts based on selected location
  useEffect(() => {
    const locContacts = locationContactsForTarget;
    setContactTarget(null);
    setInvoiceData((prev) => {
      const sameContact = prev.contactList === locContacts;
      const sameShip = prev.shipTo === (locationTarget || prev.shipTo);
      if (sameContact && sameShip) return prev;
      return {
        ...prev,
        shipTo: locationTarget || prev.shipTo,
        contact: locContacts,
        contactList: locContacts,
      };
    });
  }, [locationContactsForTarget, locationTarget]);

  const applyTaxRateFromLocation = async (loc) => {
    const state = loc?.shippingState
    const zip = loc?.shippingZip
    if (!state || !zip) return

    try {
      const { data } = await fetchTaxRate({ state, zip })
      const percent = data.estimatedCombinedRate > 1 ? data.estimatedCombinedRate : data.estimatedCombinedRate * 100
      setRates(percent)
      setInvoiceData((prev) => ({ ...prev, rates: percent }))
    } catch (error) {
      console.log('Tax rate lookup failed', error)
    }
  }

  const handleDeliveryFeeChange = (e) => {
    let value = 0
    if (e.target.value && e.target.value !== '') {
      value = parseInt(e.target.value)
    }
    setDeliveryFee(value)
    
    setInvoiceData((prevState) => ({ ...prevState, deliveryFee: value}));
  }

  const handleDeliveryFeeOverride = (e) => {
    setDeliveryFeeOverride(e.target.checked);
    setInvoiceData((prevState) => ({ ...prevState, deliveryFeeOverride: e.target.checked}));
  }

  const handleDoNotOrderClick = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.checked;
    if (values[index]['lockup'] === true) {
      values[index][e.target.name] = !e.target.checked;
      e.target.checked = false;
      openSnackbar('Deselect lockup to select inventory.')
    } else {
      if (e.target.checked) {
          let inv = inventories.find(obj => {
            if (obj.modelNumber === values[index]['modelNumber']) {
              if (obj.quantity < values[index]['quantity']) {
                openSnackbar(`There are only ${obj.quantity} ${obj.modelNumber} in inventory.`)
                values[index][e.target.name] = !e.target.checked;
                e.target.checked = false;
              } else {
                values[index]['unitPrice'] = formatCentsToDollars(obj.price);
                values[index]['unitCost'] = formatCentsToDollars(obj.cost);
                setDno(obj);
              }
              return true;
            } else {
              return false;
            }
          })
          if (inv === undefined) {
              openSnackbar(`${values[index]['modelNumber']} is not in inventory.`)
              values[index][e.target.name] = !e.target.checked;
              e.target.checked = false;
          }
      } else {
        products.find(obj => {
          if (obj.modelNumber === values[index]['modelNumber']) {
            values[index]['unitPrice'] = formatCentsToDollars(obj.price);
            values[index]['unitCost'] = formatCentsToDollars(obj.cost);
            return true;
          } else {
            return false;
          }
        })
      }
    }
    setInvoiceData({...invoiceData, items: values})
  }

  const handleLockupClick = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.checked;
    if (values[index]['doNotOrder'] === true) {
      values[index][e.target.name] = !e.target.checked;
      e.target.checked = false;
      openSnackbar('Deselect inventory to select lockup.')
    } else {
      if (e.target.checked) {
        let l = lockups.find(obj => {
          if (obj.modelNumber === values[index]['modelNumber']) {
            if (obj.quantity < values[index]['quantity']) {
              openSnackbar(`There are only ${obj.quantity} ${obj.modelNumber} in lockup.`)
              values[index][e.target.name] = !e.target.checked;
              e.target.checked = false;
            } else {
              values[index]['unitPrice'] = formatCentsToDollars(obj.price);
              values[index]['unitCost'] = formatCentsToDollars(obj.cost);
              setLockup(obj);
            }
            return true;
          } else {
            return false;
          }
        })
        if (l === undefined) {
            openSnackbar(`${values[index]['modelNumber']} is not in lockup.`)
            values[index][e.target.name] = !e.target.checked;
            e.target.checked = false;
        }
    } else {
      products.find(obj => {
        if (obj.modelNumber === values[index]['modelNumber']) {
          values[index]['unitPrice'] = formatCentsToDollars(obj.price);
          values[index]['unitCost'] = formatCentsToDollars(obj.cost);
          return true;
        } else {
          return false;
        }
      })
    }
    }
    setInvoiceData({...invoiceData, items: values})
  }

  const handleProductChange = (index, e, value) => {
    setProduct(value);
    const values = [...invoiceData.items];
    if (value !== null) {
      values[index]['modelNumber'] = value.modelNumber;
      values[index]['unitPrice'] = formatCentsToDollars(value.price);
      values[index]['unitCost'] = formatCentsToDollars(value.cost);
    } else {
      values[index]['modelNumber'] = '';
      values[index]['unitPrice'] = '';
      values[index]['unitCost'] = '';
    }
    setInvoiceData({ ...invoiceData, items: values });
  }

  const handleAccountChange = (value) => {
    setAccount(value);
    setLocationTarget(null);
    setContactTarget(null);
    const billSnapshot = value ? {
      accountId: value._id,
      name: value.name,
      billingAddress: value.billingAddress,
      billingCity: value.billingCity,
      billingState: value.billingState,
      billingZip: value.billingZip,
      taxIdNumber: value.taxIdNumber,
      term: value.term,
      phone: value.phone,
      email: value.email,
    } : null
    setInvoiceData((prev) => ({
      ...prev,
      billTo: billSnapshot,
      client: billSnapshot ? {
        store: billSnapshot.name,
        address: billSnapshot.billingAddress,
        city: billSnapshot.billingCity,
        state: billSnapshot.billingState,
        zipCode: billSnapshot.billingZip,
        taxIdNumber: billSnapshot.taxIdNumber,
        term: billSnapshot.term,
        email: billSnapshot.email,
        cellPhone: billSnapshot.phone,
      } : prev.client,
      shipTo: billSnapshot ? null : prev.shipTo,
      contact: billSnapshot ? null : prev.contact,
    }))
    if (value) {
      let tempDueDate = moment(selectedRbDate).add(value.term || 1, 'days');
      setSelectedDate(tempDueDate); 
    } else {
      let tempDueDate = moment(selectedRbDate).add(1, 'days');
      setSelectedDate(tempDueDate);
    }
    handleContactChange(null)
  }

  const handleLocationChange = (value) => {
    setLocationTarget(value);
    const contactsForLocation = value
      ? (Array.isArray(value.contacts) && value.contacts.length
          ? value.contacts
          : contacts.filter((c) => c.locationId === value._id))
      : [];
    const shipSnapshot = value ? {
      locationId: value._id,
      accountId: value.accountId,
      name: value.name,
      shippingAddress: value.shippingAddress,
      shippingCity: value.shippingCity,
      shippingState: value.shippingState,
      shippingZip: value.shippingZip,
      phone: value.phone || value.cellPhone,
      email: value.email,
      active: value.active,
    } : null
    setContactTarget(contactsForLocation.length ? contactsForLocation : null);
    setInvoiceData((prev) => ({ ...prev, shipTo: shipSnapshot, contact: contactsForLocation.length ? contactsForLocation : null }))
    if (value) {
      applyTaxRateFromLocation(value)
    } 
  }

  const handleContactChange = (value) => {
    setContactTarget(value);
    const contactSnapshot = value ? {
      contactId: value._id,
      accountId: value.accountId,
      locationId: value.locationId,
      name: value.name,
      role: value.role,
      email: value.email,
      phone: value.phone,
      primary: value.primary,
    } : null
    setInvoiceData((prev) => ({ ...prev, contact: contactSnapshot }))
  }

  // console.log(invoiceData)
  // Change handler for dynamically added input field
  const handleChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
    console.log(values);
    setInvoiceData({ ...invoiceData, items: values });
  };

  const handleQuantityChange = (index, e) => {
    const values = [...invoiceData.items];
    if (values[index]['lockup'] === true || values[index]['doNotOrder'] === true) {
      let arr = values[index]['lockup'] ? lockups : inventories
      let str = values[index]['lockup'] ? 'lockup' : 'inventory'
      let l = arr.find(obj => {
        if (obj.modelNumber === values[index]['modelNumber']) {
          if (invoice) {
            let originalQty = (parseInt(obj.quantity)) + parseInt(originalItems.current[index]['quantity'])
            if ( originalQty < values[index]['quantity']) {
              openSnackbar(`There are only ${originalQty} ${obj.modelNumber} in ${str}.`)
              values[index][e.target.name] = originalItems.current[index]['quantity'];
            } else {
              values[index]['unitPrice'] = formatCentsToDollars(obj.price);
              values[index]['unitCost'] = formatCentsToDollars(obj.cost);
              values[index][e.target.name] = e.target.value;
            }
            return true;
          }
          else {
            if (obj.quantity < values[index]['quantity']) {
              openSnackbar(`There are only ${obj.quantity} ${obj.modelNumber} in ${str}.`)
              values[index][e.target.name] = originalItems.current[index]['quantity'];
            } else {
              values[index]['unitPrice'] = formatCentsToDollars(obj.price);
              values[index]['unitCost'] = formatCentsToDollars(obj.cost);
              values[index][e.target.name] = e.target.value;
            }
            return true;
          }
          
        } else {
          return false;
        }
      })
      if (l === undefined) {
          openSnackbar(`${values[index]['modelNumber']} is not in ${str}.`)
          values[index][e.target.name] = originalQuantity;
      }
    }
    setInvoiceData({ ...invoiceData, items: values });
  };


  const handlePriceChange = (index, e) => {
    const values = [...invoiceData.items];
    values[index][e.target.name] = e.target.value;
  }

  useEffect(() => {
    //Get the subtotal
    const subTotal = () => {
      var arr = document.getElementsByName("amount");
      var subtotal = 0;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].value) {
          subtotal += +arr[i].value;
        }
        // document.getElementById("subtotal").value = subtotal;
        setSubTotal(subtotal);
      }
      if (!deliveryFeeOverride) {
        setDeliveryFee(0.00)
      }
    };

    subTotal();
  }, [invoiceData]);

  // useEffect(() => {
  //   if (client) {
  //     let tempDueDate = moment(selectedRbDate).add(client.term, 'days');
  //     setSelectedDate(tempDueDate); 
  //   } else {
  //     let tempDueDate = moment(selectedRbDate).add(1, 'days');
  //     setSelectedDate(tempDueDate);
  //   }
  // }, [client])

  useEffect(() => {
    const total = () => {
      //Tax rate is calculated as (input / 100 ) * subtotal + subtotal
      
      //VAT is calculated as tax rates /100 * subtotal
      const haulFee = haulAway ? 40 : 0;
      const walkFee = getWalkUpFee(walkUp);
      const taxableBase = subTotal + deliveryFee + haulFee + walkFee;
      let cents = formatDollarsToCents(taxableBase);
      let totalTaxCents = (rates / 100) * cents;
      let totalTax = parseFloat(formatCentsToDollars(totalTaxCents).toFixed(2));
      const overallSum = totalTax + taxableBase;
      setSalesTax(totalTax);
      setTotal(overallSum);
    };
    total();
  }, [invoiceData, rates, subTotal, deliveryFee, haulAway, walkUp]);

  const haulFee = haulAway ? 40 : 0;
  const walkFee = getWalkUpFee(walkUp);
  const taxableBase = subTotal + deliveryFee + haulFee + walkFee;

  const handleAddField = (e) => {
    e.preventDefault();
    setInvoiceData((prevState) => ({
      ...prevState,
      items: [
        ...prevState.items,
        { modelNumber: "", unitPrice: "", quantity: "", amount: "", unitCost: "", discount: "", doNotOrder: false, lockup: false },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    const values = invoiceData.items;
    values.splice(index, 1);
    if (values.length === 0) {
      setInvoiceData((prevState) => ({
        ...prevState,
        items: [
          { modelNumber: "", unitPrice: "", quantity: "", amount: "", unitCost: "", discount: "", doNotOrder: false, lockup: false },
        ],
      }));
    } else {  
      setInvoiceData((prevState) => ({ ...prevState, values }));
    }
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...invoiceData,
      billTo: invoiceData.billTo || null,
      shipTo: invoiceData.shipTo || null,
      contact: (locationContactsForTarget && locationContactsForTarget.length) ? locationContactsForTarget : (invoiceData.contact || []),
      contactList: (locationContactsForTarget && locationContactsForTarget.length)
        ? locationContactsForTarget
        : (invoiceData.contactList || []),
      haulAway,
      walkUp,
      client: invoiceData.billTo ? {
        store: invoiceData.billTo.name,
        address: invoiceData.billTo.billingAddress,
        city: invoiceData.billTo.billingCity,
        state: invoiceData.billTo.billingState,
        zipCode: invoiceData.billTo.billingZip,
        taxIdNumber: invoiceData.billTo.taxIdNumber,
        term: invoiceData.billTo.term,
        email: invoiceData.billTo.email,
        cellPhone: invoiceData.billTo.phone,
      } : invoiceData.client,
      subTotal: taxableBase,
      total: total,
      salesTax: salesTax,
      rates: rates,
      dueDate: selectedDate,
      receivedByDate: selectedRbDate,
      deliveryFee: deliveryFee,
      deliveryFeeOverride: deliveryFeeOverride,
      type: type,
      status: status,
      paymentRecords: invoiceData.paymentRecords || [],
    }
    if (invoice) {
      dispatch(
        updateInvoice(invoice._id, {
          ...payload
        })
      );
      invoiceData.items.forEach((item, index) => {
        const originalItem = originalItems.current[index] || {
          lockup: false,
          doNotOrder: false,
          quantity: 0,
          modelNumber: "",
        };
        let l = lockups.find(obj => {
          if (item.lockup || originalItem.lockup) {
            if ((item.modelNumber === obj.modelNumber) || (originalItem.lockup === obj.modelNumber)) {
              return true;
            }
          }
        });
        if (l !== undefined) {
          if (originalItem.lockup === false) {
            l.quantity -= item.quantity;
          } else {
            if (originalItem.quantity < item.quantity) {
              l.quantity -= (item.quantity - originalItem.quantity)
            } else if (originalItem.quantity > item.quantity) {
              l.quantity += (originalItem.quantity - item.quantity)
            } else {
              if (item.lockup === false)
              {
                l.quantity += parseInt(item.quantity);
              } 
            }
          }
          dispatch(updateLockup(l._id, l, openSnackbar))
        }
        let inv = inventories.find(obj => {
          if (item.doNotOrder || originalItem.doNotOrder) {
            if ((item.modelNumber === obj.modelNumber) || (originalItem.doNotOrder === obj.modelNumber)) {
              return true;
            }
          }
        });
        if (inv !== undefined) {
          if (originalItem.doNotOrder === false) {
            inv.quantity -= item.quantity;
          } else {
            if (originalItem.quantity < item.quantity) {
              inv.quantity -= (item.quantity - originalItem.quantity)
            } else if (originalItem.quantity > item.quantity) {
              inv.quantity += (originalItem.quantity - item.quantity)
            } else {
              if (item.doNotOrder === false) {
                inv.quantity += item.quantity;
              }
              
            }
          }
          dispatch(updateInventory(inv._id, inv, openSnackbar))
        }
      })
      history.push(`/invoice/${invoice._id}`);
    } else {
      dispatch(
        createInvoice(
          {
            ...payload,
            invoiceNumber: `${
              invoiceData.invoiceNumber < 100
                ? Number(invoiceData.invoiceNumber).toString().padStart(3, "0")
                : Number(invoiceData.invoiceNumber)
            }`,
            creator: [user?.result?._id || user?.result?.googleId],
          },
          history
        )
      );
      invoiceData.items.forEach(item => {
        let l = lockups.find(obj => {
          if (item.lockup) {
            if (item.modelNumber === obj.modelNumber) {
              return true;
            }
          }
        });
        if (l !== undefined) {
          l.quantity -= item.quantity;
          dispatch(updateLockup(l._id, l, openSnackbar))
        }
        let inv = inventories.find(obj => {
          if (item.doNotOrder) {
            if (item.modelNumber === obj.modelNumber) {
              return true;
            }
          }
        });
        if (inv !== undefined) {
          inv.quantity -= item.quantity;
          dispatch(updateInventory(inv._id, inv, openSnackbar))
        }
      })
    }

    // setInvoiceData(initialState)
  };

  const classes = useStyles();
  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  if (!user) {
    history.push("/login");
  }

  return (
    <div className={styles.invoiceLayout}>
      <form onSubmit={handleSubmit} className="mu-form">
        <Container className={classes.headerContainer}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" style={{ color: "gray" }}>
                Invoice #
              </Typography>
              <Typography variant="h6" style={{ fontWeight: 700 }}>
                {invoiceData.invoiceNumber || nextInvoiceNumber || 'Pending'}
              </Typography>
              <Grid container spacing={1} style={{ marginTop: 4, marginBottom: 8 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="PC Invoice #"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={invoiceData.pcInvoiceNumber || ''}
                    onChange={(e) => setInvoiceData((prev) => ({ ...prev, pcInvoiceNumber: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Client PO #"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={invoiceData.clientPONumber || ''}
                    onChange={(e) => setInvoiceData((prev) => ({ ...prev, clientPONumber: e.target.value }))}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <InvoiceType type={type} setType={setType} />
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Container>
          <Grid
            container
            spacing={3}
            alignItems="flex-start"
            justifyContent="space-between"
            wrap="nowrap"
            style={{ marginTop: "40px" }}
          >
            <Grid item xs={12} md={8}>
              <Container>
                <Typography
                  variant="overline"
                  style={{ color: "gray", paddingRight: "3px" }}
                  gutterBottom
                >
                  Bill to
                </Typography>

                {account && (
                  <>
                    <Typography variant="subtitle2" gutterBottom>
                      {account.name}
                    </Typography>
                    <Typography variant="body2">{account.email}</Typography>
                    <Typography variant="body2">{account.phone}</Typography>
                    <Typography variant="body2">{account.billingAddress}</Typography>
                    <Typography variant="body2">{[account.billingCity, account.billingState, account.billingZip].filter(Boolean).join(', ')}</Typography>
                    <Button
                      color="primary"
                      size="small"
                      style={{ textTransform: "none" }}
                      onClick={() => handleAccountChange(null)}
                    >
                      Change
                    </Button>
                  </>
                )}
                <div
                  style={account ? { display: "none" } : { display: "block" }}
                >
                  <Autocomplete
                    options={accountOptions}
                    getOptionLabel={(option) => option.name || ''}
                    PaperComponent={CustomPaper}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required={!invoice && true}
                        label="Select Account"
                        margin="dense"
                        variant="outlined"
                        size="small"
                      />
                    )}
                    value={account}
                    onChange={(event, value) => handleAccountChange(value)}
                    style={{ maxWidth: 300 }}
                  />
                </div>
                <Grid container spacing={2} style={{ marginTop: 12 }}>
                  <Grid item xs={12} sm={6} style={{ width: '100%' }}>
                    <Typography variant="overline" style={{ color: "gray" }} gutterBottom>
                      Ship To
                    </Typography>
                    {locationTarget ? (
                      <>
                        <Typography variant="subtitle2" gutterBottom>
                          {locationTarget.name}
                        </Typography>
                      <Typography variant="body2">{locationTarget.shippingAddress}</Typography>
                      <Typography variant="body2">
                        {[locationTarget.shippingCity, locationTarget.shippingState, locationTarget.shippingZip].filter(Boolean).join(', ')}{locationTarget.phone ? ` ${locationTarget.phone}` : ''}
                      </Typography>
                        <Button
                          color="primary"
                          size="small"
                          style={{ textTransform: "none", marginTop: 6 }}
                          onClick={() => { setLocationTarget(null); setInvoiceData((prev) => ({ ...prev, shipTo: null })); }}
                        >
                          Change
                        </Button>
                      </>
                    ) : (
                      <Autocomplete
                        options={locationOptions}
                        getOptionLabel={(option) => option.name || ''}
                        PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Location"
                            margin="dense"
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        )}
                        value={locationTarget}
                        onChange={(event, value) => handleLocationChange(value)}
                        disabled={!account && accounts.length > 0}
                        style={{ width: '100%', maxWidth: 480 }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} style={{ width: '100%' }}>
                    <Typography variant="overline" style={{ color: "gray" }} gutterBottom>
                      Contact
                    </Typography>
                    {locationContactsForTarget.length ? (
                      locationContactsForTarget.map((c) => (
                        <div key={c._id || c.name} style={{ marginBottom: 4 }}>
                          <Typography variant="subtitle2" gutterBottom>
                            {c.name} {c.primary ? '• Primary' : ''}
                          </Typography>
                          <Typography variant="body2">{[c.phone].filter(Boolean).join(' • ')}</Typography>
                        </div>
                      ))
                    ) : (
                      <Typography variant="body2" color="textSecondary">No contacts for this location.</Typography>
                    )}
                  </Grid>
                </Grid>
              </Container>
            </Grid>

            <Grid item xs={12} md={4} style={{ marginRight: 20, textAlign: "right", minWidth: 240 }}>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Status
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                style={{ color: type === "Receipt" ? "green" : "red" }}
              >
                {type === "Receipt" ? "Paid" : "Unpaid"}
              </Typography>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Date
              </Typography>
              <Typography variant="body2" gutterBottom>
              {selectedRbDate
                  ? moment(selectedRbDate).format("MMM Do YYYY")
                  : "27th Sep 2021"}
              </Typography>
              <Typography
                variant="overline"
                style={{ color: "gray" }}
                gutterBottom
              >
                Due Date
              </Typography>
              <Typography variant="body2" gutterBottom>
                {selectedDate
                  ? moment(selectedDate).format("MMM Do YYYY")
                  : "27th Sep 2021"}
              </Typography>
              <Typography variant="overline" gutterBottom>
                Amount
              </Typography>
              <Typography variant="h6" gutterBottom>
                ${toCommas(total.toFixed(2))}
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <div>
          <TableContainer component={Paper} className="tb-container">
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Item</TableCell>
                  <TableCell>Qty</TableCell>
                  <TableCell>#</TableCell>
                  <TableCell>Cost ($)</TableCell>
                  <TableCell>Price ($)</TableCell>
                  {/* <TableCell>Disc (%)</TableCell> */}
                  <TableCell>Amount</TableCell>
                  <TableCell>Inv.</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData.items.map((itemField, index) => (
                  <TableRow key={index}>
                    <TableCell scope="row" style={{ width: "40%" }}>
                      {" "}
                      {itemField.modelNumber && (
                        <>
                            <Typography variant="subtitle1" gutterBottom>
                                {itemField.modelNumber}
                            </Typography>
                        </>
                        )}
                        <div style={itemField.modelNumber ? { display: "none" } : { display: "block" }}>
                        <Autocomplete
                            options={products.sort((a, b) => {
                            if (
                                a.hasOwnProperty("brand") &&
                                b.hasOwnProperty("brand")
                            ) {
                                return -b.brand.localeCompare(a.brand);
                            }
                            })}
                            groupBy={(option) => option.brand}
                            getOptionLabel={(option) => option.modelNumber || ""}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                name="product"
                                label="Select Product"
                                margin="normal"
                                variant="outlined"
                            />
                            )}
                            value={itemField.modelNumber}
                            onChange={(e, value) => handleProductChange(index, e, value)}
                        />
                        </div>
                      {" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="quantity"
                        onChange={(e) => handleChange(index, e)}
                        onBlur={(e) => handleQuantityChange(index, e)}
                        value={itemField.quantity}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                    {" "}
                      <FormGroup>
                        <FormControlLabel control={
                          <Checkbox
                            name="lockup"
                            checked={itemField.lockup}
                              color="primary"
                              onChange={(e) => handleLockupClick(index, e)}
                          />} label="" />
                      </FormGroup>{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="unitCost"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.unitCost}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="unitPrice"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.unitPrice}
                        placeholder="0"
                      />{" "}
                    </TableCell>
                    {/* <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="discount"
                        onChange={(e) => handleChange(index, e)}
                        value={itemField.discount}
                        placeholder="0"
                      />{" "}
                    </TableCell> */}
                    <TableCell align="right">
                      {" "}
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        type="number"
                        name="amount"
                        onChange={(e) => handleChange(index, e)}
                        value={
                          (itemField.quantity * itemField.unitPrice -
                          (itemField.quantity *
                            itemField.unitPrice *
                            itemField.discount) /
                            100).toFixed(2)
                        }
                        disabled
                      />{" "}
                    </TableCell>
                    <TableCell align="right">
                    {" "}
                      <FormGroup>
                        <FormControlLabel control={
                          <Checkbox
                            name="doNotOrder"
                            checked={itemField.doNotOrder}
                              color="primary"
                              onChange={(e) => handleDoNotOrderClick(index, e)}
                          />} label="" />
                      </FormGroup>{" "}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton onClick={() => handleRemoveField(index)}>
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={styles.addButton}>
            <button onClick={handleAddField}>+</button>
          </div>
        </div>

        <div className={styles.invoiceSummary}>
          <div className={styles.summary}>Invoice Summary</div>
          <div className={styles.summaryItem}>
            <p>Delivery Fee:</p>
            <h4>${(deliveryFee).toFixed(2)}</h4>
          </div>
          {haulAway && (
            <div className={styles.summaryItem}>
              <p>Haul Away:</p>
              <h4>${haulFee.toFixed(2)}</h4>
            </div>
          )}
          {walkUp && (
            <div className={styles.summaryItem}>
              <p>Walk Up ({walkUp}):</p>
              <h4>${walkFee.toFixed(2)}</h4>
            </div>
          )}
          <div className={styles.summaryItem}>
            <p>Sub total:</p>
            <h4>${(taxableBase).toFixed(2)}</h4>
          </div>
          <div className={styles.summaryItem}>
            <p>Sales Tax:</p>
            <h4>${(salesTax).toFixed(2)}</h4>
          </div>
          <div className={styles.summaryItem}>
            <p>Total</p>
            <h4 style={{ color: "black", fontSize: "18px", lineHeight: "8px" }}>
               ${toCommas(total.toFixed(2))}
            </h4>
          </div>
        </div>

        <div className={styles.toolBar}>
          <Container>
            <Grid container>
              <Grid item style={{ marginTop: "16px", marginRight: 10 }}>
                <TextField
                  type="text"
                  step="any"
                  name="rates"
                  id="rates"
                  value={rates}
                  onChange={handleRates}
                  placeholder="e.g 10"
                  label="Tax Rates(%)"
                />
              </Grid>
              <Grid item style={{ marginTop: "16px", marginRight: 10 }}>
                <TextField
                  type="text"
                  step="any"
                  name="delivery"
                  id="delivery"
                  value={deliveryFee}
                  onChange={handleDeliveryFeeChange}
                  label="Delivery Fee ($)"
                />
              </Grid>
              <Grid item style={{ marginTop: "30px", marginRight: 10 }}>
                <FormGroup>
                    <FormControlLabel control={<Checkbox
                              color="primary"
                              onChange={handleDeliveryFeeOverride}
                          />} label="Fee Override" />
                  </FormGroup>
              </Grid>
              <Grid item style={{ marginTop: "24px", marginRight: 10 }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={haulAway}
                        onChange={(e) => {
                          setHaulAway(e.target.checked)
                          setInvoiceData((prev) => ({ ...prev, haulAway: e.target.checked }))
                        }}
                      />
                    }
                    label="Haul Away ($40)"
                  />
                </FormGroup>
              </Grid>
              <Grid item style={{ marginTop: "16px", marginRight: 10, minWidth: 180 }}>
                <Autocomplete
                  options={['', ...Object.keys(WALK_UP_FEES)]}
                  getOptionLabel={(opt) => opt ? `${opt} (+$${WALK_UP_FEES[opt]})` : 'None'}
                  value={walkUp}
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Walk Up"
                      margin="dense"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  onChange={(event, value) => {
                    const val = value || ''
                    setWalkUp(val)
                    setInvoiceData((prev) => ({ ...prev, walkUp: val }))
                  }}
                />
              </Grid>
              <Grid item style={{ marginRight: 10 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Received By Date"
                    format="MM/dd/yyyy"
                    value={selectedRbDate}
                    onChange={handleRbDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item style={{ marginRight: 10 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Due date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={styles.note}>
          <h4>Note/Payment Info</h4>
          <textarea
            style={{ border: "solid 1px #d6d6d6", padding: "10px" }}
            placeholder="Provide additional details or terms of service"
            onChange={(e) =>
              setInvoiceData({ ...invoiceData, notes: e.target.value })
            }
            value={invoiceData.notes}
          />
        </div>

        {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        <Grid container justifyContent="center">
          <Button
            id="save-invoice"
            variant="contained"
            style={{ justifyContentContent: "center" }}
            type="submit"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Save and Continue
          </Button>
        </Grid>
      </form>
    </div>
  );
};

export default Invoice;
